/**
* Journey component
*
* first developped for SynchroNyme
*
* @param {object} data : journey object as described in http://projets2.afidium.com/projects/wnj/repository/entry/Afidium_Rest_API/Source/api/group/hosts/GRP_get_get_booking+merge.json
*   "journey": {
-"direction": "Return",
-"direction+§doc": {"§desc": "(1) {OneWay, Return}: journey is a one way (PAR NYC) or return trip (PAR NYC PAR)"},
-"carrier": "AF",
-"carrier+§doc": {"§desc": "(1) {(ISO:code)} : The main carrier of the routing"},
-"from": "PAR",
-"from+§doc": {"§desc": "(1) {(IATA:code)} The city or airport of origin, as IATA code or detailled object"},
-"to": {
-   "id": 12117,
-   "name": "New York",
-   "code": "NYC",
-   "type": "City"
-},
-"to+§doc": {"§desc": "(1) {(afi:location)} The city or airport as IATA code or detailled object"},
-"begin": "2016-01-11",
-"begin+§doc": {"§desc": "(1) {(ISO:date)} : The begin of the first segment"},
-"end": "2016-01-18",
-"end+§doc": {"§desc": "(0..1) {(ISO:date)} : The begin of the first segment of the return"}
-            }
*
**/

import _isObject from 'lodash-es/isObject';

import { faArrowRight, IconDefinition} from "@fortawesome/free-solid-svg-icons";

//Angular Core
import { Component, Input } from '@angular/core';

@Component({

    selector: 'journey',
    templateUrl: 'journey.component.html',
    styleUrls: [ 'journey.component.scss']
})

export class JourneyComponent {
    @Input() data: any;
    @Input() noArrow: boolean= false;

    public iconArrowRight: IconDefinition = faArrowRight;

    dateFormat = sessionStorage.getItem('dateFormat');

    /**
    * test if _testValue is an object
    * @param {any} _testValue : value to test
    **/
    isObject(_testValue: any): boolean{
        return _isObject(_testValue)
    }

}
